module.exports = __webpack_public_path__ + "static/media/default.4b1287b9.png";